import { useEffect, useState } from 'react'
import { Box, Typography, Modal } from '@material-ui/core'
import { connect } from 'react-redux'
import axios from 'axios'
import urlStrings from '../../utils/urlStrings'
import FilledButton from '../FilledButton'
import history from '../../routes/history'
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined'
import CustomDialog from '../CustomDialog'
import _ from 'lodash'
import { getSessionToken } from '../../utils/helper'
import { applicationService } from '../../Services/ApplicationService'
import { useStyles } from './styles'
import Loader from '../../utils/loader'

const ApprovePopUp = (props) => {
  const {
    setConfirmed,
    setApprove,
    currentSiteID,
    setLoading,
    getSites,
    setMessage,
    setModal,
  } = props
  const classes = useStyles()
  const [open, setOpen] = useState(true)
  return (
    <div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
      >
        <div className={classes.paper}>
          <Box className={classes.header}>
            <Typography className={classes.text}>
              Are you sure you want to approve
            </Typography>
            <Typography className={classes.text}>application?</Typography>
          </Box>

          <Box className={classes.options}>
            <FilledButton
              label="Yes"
              width="120px"
              height="36px"
              primary={true}
              onClick={ () => {
                setLoading(true)
                applicationService.approveApplicationBySiteId(currentSiteID)
                  .then((success) => {
                    setLoading(false)
                    setConfirmed(true)
                    setApprove(false)
                    setOpen(false)
                    getSites()
                  })
                  .catch((error) => {
                    const displayMessage = _.get(
                      error,
                      'data.error.displayMessage',
                      'Something went wrong',
                    )
                    setModal(true)
                    setMessage(displayMessage)
                    setLoading(false)
                    setApprove(false)
                    setOpen(false)
                  })
              }}
            ></FilledButton>
            <FilledButton
              label="No"
              width="120px"
              height="36px"
              primary={false}
              tertiary={true}
              onClick={() => {
                setConfirmed(false)
                setApprove(false)
                setOpen(false)
              }}
            ></FilledButton>
          </Box>
        </div>
      </Modal>
    </div>
  )
}
const mapStateToProps = ({ applications }) => {
  const { currentSiteID } = applications
  return { currentSiteID }
}
export default connect(mapStateToProps, null)(ApprovePopUp)
